import CryptoJS from "crypto-js";

// Hàm để tính checksum MD5 của file

const calculateMD5Checksum = (file) => {
  return new Promise((resolve, reject) => {
    const chunkSize = 100 * 1024 * 1024; // Chunk size: 1MB
    const fileSize = file.size;
    let offset = 0;
    const hasher = CryptoJS.algo.MD5.create();

    const reader = new FileReader();

    reader.onload = function (event) {
      const chunk = event.target.result;
      const wordArray = CryptoJS.lib.WordArray.create(chunk);
      hasher.update(wordArray);

      offset += chunk.byteLength;
      if (offset < fileSize) {
        readNextChunk();
      } else {
        resolve(hasher.finalize().toString(CryptoJS.enc.Hex));
      }
    };

    reader.onerror = function (event) {
      reject("");
    };

    function readNextChunk() {
      const chunk = file.slice(offset, offset + chunkSize);
      reader.readAsArrayBuffer(chunk);
    }

    readNextChunk();
  });
};

export default calculateMD5Checksum;
